import { useEffect, useRef, DependencyList } from 'react'

const useEffectOnce = (
    callback: () => void,
    condition: boolean,
    deps: DependencyList = []
) => {
    const hasRun = useRef(false)

    useEffect(() => {
        if (!hasRun.current && condition) {
            hasRun.current = true
            callback()
        }
    }, [condition, ...deps])
}

export default useEffectOnce
